import { useMutation } from '@tanstack/react-query';
import { getAllAlternatives } from "@/api/alternative"; 
import { GetAllAlternativesQuery } from "@/types"; 
import { PostParam } from "@/types/index"; 

export function useGetAllAlternatives(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<any, Error, GetAllAlternativesQuery>({
    mutationFn: getAllAlternatives,
    onSuccess,
    onError
  });
}